/**
 * https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/components/nav-stepper
 */
import * as typestyle from 'typestyle';
import * as React from 'react';
import * as gls from '../layout/gls';
import * as csstips from 'csstips';
import * as types from "typestyle/lib/types";

import { Current, Done, Pending } from './icons';
import { colors, fontFamily, fontSizes } from './styles';

namespace StepperStyles {
  export const pendingColor = colors.warmGrey4;
  export const currentColor = colors.current;
  export const doneColor = colors.success;

  export const itemRootClass = typestyle.style(
    csstips.centerJustified,
    { position: 'relative' }
  );

  export const clickableClassName = typestyle.style({
    cursor: 'pointer',
    $nest: {
      '&:hover': {
        color: doneColor,
        textDecoration: 'underline',
      }
    }
  });
  export const labelClassName = typestyle.style({
    fontSize: fontSizes.smallText,
    fontFamily: fontFamily.arial,
    marginTop: '10px'
  });

  const hrBaseStyles: types.NestedCSSProperties = {
    position: 'absolute',
    width: 'calc(100% - 100px)',
    left: 'calc(50% + 50px)',
    top: '18%',
  }
  export const hrDoneClassName = typestyle.style(
    hrBaseStyles,
    {
      borderTop: `1px solid ${colors.warmGrey3}`
    }
  );
  export const hrPendingClassName = typestyle.style(
    hrBaseStyles,
    {
      borderTop: `2px dotted ${colors.warmGrey3}`
    }
  );
}

type Step = {
  /**
   * If not provided you don't get the hand style
   * PS: Only past steps get hand icon or onClick triggering
   */
  onClick?: () => any;
  text: string;
}

interface StepperProps {
  steps: Step[],
  /** 0 based */
  current: number,
}

export class Stepper extends React.Component<StepperProps, {}>{
  render() {
    const {props} = this;
    const {current} = props;

    return (
      <gls.FlexHorizontal>
        {
          props.steps.map((s, i) =>
            <gls.Flex
              key={i}
              className={typestyle.classes(
                StepperStyles.itemRootClass,
                (s.onClick && i < current) && StepperStyles.clickableClassName
              )}
              onClick={(s.onClick && i < current) ? s.onClick : () => null}>

              <div style={csstips.horizontallyCenterChildren}>
                {
                  i < current ? <Done />
                    : i === current ? <Current />
                      : <Pending />
                }
                {
                  i < current ? <StepLabel color={StepperStyles.doneColor} index={i} text={s.text} />
                    : i === current ? <StepLabel color={StepperStyles.currentColor} index={i} text={s.text} />
                      : <StepLabel color={StepperStyles.pendingColor} index={i} text={s.text} />
                }
              </div>

              {
                i < current ? <div className={StepperStyles.hrDoneClassName}>&nbsp;</div>
                  : (i !== (props.steps.length - 1)) && <div className={StepperStyles.hrPendingClassName}>&nbsp;</div>
              }

            </gls.Flex>
          )
        }
      </gls.FlexHorizontal>
    );
  }
}

const StepLabel = (props: { index: number, text: string, color: string }) => {
  return (
    <div className={StepperStyles.labelClassName} style={{ color: props.color }}>{props.index + 1}. {props.text}</div>
  );
}
